import { useState, useEffect, useContext, useRef } from "react";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, Input, Tooltip } from "@fluentui/react-components";
import { Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, AddSquare20Regular, KeyResetRegular, SlideEraser20Regular, Delete20Regular, Settings20Regular, Info16Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { ToastComponent } from "../../components/toast/toast.component";
import { GlobalContext } from "../../hooks/globalContext";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { RJSFSchema } from '@rjsf/utils';
import { CustomWidgets } from "../../components/form-components";
import { Form } from "@rjsf/fluent-ui";
import { Users_func } from "../../api/user/users_func";
import { useApolloClient } from "@apollo/client";
import { primaryIcon, secondaryIcon, buttonContent, DynamicBoxingCSS, parentHome, SubSectionResponsive, wraperStyle, dashboardTheme, BreadcrumbsBorder, timezoneInfo } from "../../styles/customStyles";
import { usePermissionStore } from "../../Store/permissionStore";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../utility/utils";
import { DatepickerComponent } from "../../components/picker/datepicker.component";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import { SSOPages } from "../../components/side_menu/InlineSidenav";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import validator from '@rjsf/validator-ajv8';
import moment from "moment-timezone";
import DialogBox from "../../components/dialog/dialog.component";

export const Approvals = () => {
  const [loading, setLoading] = useState(true);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [isEmailExistsToast, setEmailExistsToast]: any = useState(false);
  const [deleteUserToast, setdeleteUserToast]: any = useState(false);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [editUserDetails, setEditUserDetails] = useState(false);
  const [saveUserDetails, setSaveUserDetails] = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [deleteUser, setdeleteUser]: any = useState(false);
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [isfilter, setIsFilter] = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [rowID, setRowID]: any = useState(null);
  const [final_data, set_final_data]: any = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [overlayName, setOverlayName] = useState('');
  const [searchVal, setSearchVal] = useState("");
  const [siteList, setSiteList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [uniqueColumn, setUniqueColumn] = useState([]);
  const [overLayData, setoverLayData]: any = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [formDataUser, setFormDataUser]: any = useState({});
  const [uischema, setUischema] = useState({});
  const [currentSelectedUserFormDetails, setCurrentSelectedUserFormDetails]: any = useState({});
  const [username, setUsername]: any = useState();
  const [uniquUSerType, setUniqueUserType] = useState([]);
  const [isApprovalPage, setIsApprovalPage] = useState(true);
  const [isdeletedisabled, setDeleteDisabled] = useState(true);
  const [messagebar1, setmessagebar1] = useState(false);
  const [messagebar2, setmessagebar2] = useState(false);
  const [rowDesc, setRowDesc]: any = useState(null);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);

  // const [deviceName, setDeviceName] = useState('');
  // const [tableData1, setTableData1] = useState([]);
  // const [emailIdSupertoken, setEmailIdSuperToken] = useState(null);
  // const [final_data1, set_final_data1]: any = useState(null);
  // const [deviceList, setDeviceList]: any = useState(null);
  // const [isForm, setIsForm] = useState(false);
  // const [tracker, setTracker] = useState(false);
  // const [leftOpen, setLeftOpen] = useState(false);
  // const [routeFlag, setRouteFlag] = useState(false);
  // const [readOnly, setReadOnly] = useState<boolean>(false);
  // const [userActivityData, setUserActivityData] = useState({});
  // const [permissions, setPermissions] = useState(['']);
  // const [isSaveEnabled, setButtonEnabled] = useState(false);

  const { permissions } = usePermissionStore();

  const contextValue: any = useContext(GlobalContext);
  const { userSessionDetails, selectedRowIdInTable, selectedRowIdInSubTable } = contextValue;
  var userTimeZone = userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const { tenantName } = contextValue;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');

  const timezoneEnum = moment.tz.names();
  const formRef = useRef(null);

  console.log("Checking the permissions: ", permissions);
  console.log("Checking the tenantName: ", tenantName);
  console.log("Timezone: ", timezoneEnum);

  useEffect(() => {
    !overlayOpen && setFormDataUser({}) && setRowID(null)
  }, [overlayOpen])

  console.log("Checking context: ", userSessionDetails)

  const handle = useFullScreenHandle();
  const client = useApolloClient(); // Get the SiteList from the db

  // const getSiteList = async () => {
  //   const { data, loading, error } = await client.query({query: getSitesListsFromSiteQuery});
  //   if (!loading && data) { setSiteList(data.install_Sites_Customers); }
  // };

  // const getRoles = async () => {
  //   const { data, loading, error } = await client.query({ query: getRolePermissionv });
  //   console.log("Data is here: ", data);
  //   if (!loading && data) { setRoleList(data.supertokens_roles); }
  // };

  useEffect(() => {
    console.log('Checking fetched sitelist: ', siteList.map((val: any) => val.sitename));
  }, [siteList]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    let name: any;
    if (overlayOpen) {
      if (formDataUser != undefined) {
        name = formDataUser.firstName;
        setUsername(name);
        console.log("Username: ", username);
      }
    }
  }, [overlayOpen, formDataUser])

  console.log("Checking form-data-user: ", formDataUser);

  // async function loadRoute() { // Check weather proper roles and permissions are there
  //   const routeAllowed = await shouldLoadRoute('Nanoheal-admin');
  //   (routeAllowed) ? setRouteFlag(true) : setRouteFlag(false) // Redirect or handle unauthorized access
  // }

  // const handleOnCLickEdit = (val: any) => { // For popup message
  //   setRowID(val.userid);
  //   setOverlayName('edit');
  //   setOverlayOpen(true);
  //   setReadOnly(true);
  // };

  const saveBtnFunc = () => { // For saving user details
    if (formDataUser == null) { /* alert("alert form is empty") */ }
    // else {
    overlayName == 'edit' ? setEditUserDetails(true) : setSaveUserDetails(true)
    // setIsToast(true) } 
    setOverlayOpen(false);
  };

  const handleEditData = (data: any) => {
    if (overlayName === 'edit') {
      let userDetails = JSON.parse(data[0].formDataEdit)
      setFormDataUser(userDetails)
      setCurrentSelectedUserFormDetails(userDetails);
      console.log('Checking userDetails: ', userDetails.role)
    };
  };

  const handleBothSetMessage = () => {
    setmessagebar1(false);
    setmessagebar2(true);
  };

  const handleFilterArray = (): any => { // if(value1 !== undefined && dropDownValue1 !== '' && dropDownValue2 !== undefined && dropDownValue2 !== '') {
    const result = dropDownValue1 + " : " + dropDownValue2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setDropDownValue1('');
    setDropDownValue2('');
    // }
  };

  const handleCloseFilter = (index: any): any => {
    console.log("Clicked...");
    setFilterArray(filterArray.filter((x, itemIndex) => itemIndex !== index)); // updatedArray
    setDropDownValue1('');
    setDropDownValue2('');
  };

  useEffect(() => {
    if (filterArray.length > 0) { setResetDisabled(false); };
  }, [filterArray]);

  useEffect(() => {
    const userTypes: any = uniquUSerType.map((item) => {
      console.log("Items: ", item);
      return { key: item, label: <Caption1> {item} </Caption1> };
    });
    setUniqueColumn(userTypes);
    console.table("Checking userTypes test: ", userTypes);
  }, [uniquUSerType]);

  const inputChange = (e: any) => {
    const { value, name } = e.target;
    console.log("Entered value: ", value);
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9 ]*$/;
    const regexN = /^[A-Za-z0-9.,!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
    const filter = name === 'filter';
    if (filter) {
      const regex = { Email: regexN, "First Name": regexS, "Last Name": regexS, Status: regexS, "User Type": regexSN };
      if (regex[dropDownValue1]?.test(value)) { setDropDownValue2(value); }
    };
    // if (filter && dropDownValue1 === ("Email")) {
    //   if (regexN.test(value)) { setDropDownValue2(value) }
    // };
    // if (filter && dropDownValue1 === ("First Name") || dropDownValue1 === ("Last Name") || dropDownValue1 === ("Status")) {
    //   if (regexS.test(value)) { setDropDownValue2(value) }
    // };
    // if (filter && dropDownValue1 === ("User Type")) {
    //   if (regexSN.test(value)) { setDropDownValue2(value) }
    // };
  };

  const tenantEnums = siteList.map((val: any) => val.sitename);
  const roleEnums = roleList?.map((role: any) => role?.role);

  const jsonSchema1: RJSFSchema = {
    "type": "object",
    "properties": {
      "firstName": {
        "type": "string",
        "title": "First name",
      },
      "lastName": {
        "type": "string",
        "title": "Last name"
      },
      "emailid": {
        "type": "string",
        "format": "email",
        "title": "Email Id"
      },
      "Tenant": {
        "type": "string",
        "title": "Tenant access",
        "enum": tenantEnums,
        "enumNames": tenantEnums
      },
      "TimeZone": {
        "type": "string",
        "title": "Time zone"
      },
      "role": {
        "type": "string",
        "title": "Role",
        "enum": roleEnums,
        "enumNames": roleEnums
      }
    },
    "required": ["firstName", "lastName", "emailid", "Tenant", "role" /* Make role required */]
  };

  const uiSchema1 = {
    "firstName": {
      "ui:widget": "text",
      "ui:required": true
    },
    "lastName": {
      "ui:widget": "text",
      "ui:required": true
    },
    "emailid": {
      "ui:widget": "text",
      "ui:required": true
    },
    'ui:submitButtonOptions': { norender: true },
    "Tenant": {
      "ui:widget": "MultipleSelectToStringTanent"
    },
    "TimeZone": {
      "ui:widget": "TimezoneSelectWidget"
    },
  };

  // Below uischema added to handle disabled state for firstName, lastName and Email
  const uiSchema2 = {
    "firstName": {
      "ui:widget": "text",
      "ui:required": true,
      "ui:disabled": true
    },
    "lastName": {
      "ui:widget": "text",
      "ui:required": true,
      "ui:disabled": true
    },
    "emailid": {
      "ui:widget": "text",
      "ui:required": true,
      "ui:disabled": true
    },
    'ui:submitButtonOptions': { norender: true },
    "Tenant": { "ui:widget": "MultipleSelectToStringTanent" },
    "TimeZone": { "ui:widget": "TimezoneSelectWidget" },
  }

  // New uiSchema added to fix hover issue in the review form (NCP-3177 - When we hover on dropbox in review and create it gets highlighted for few parameters)
  const uiSchemaDisabled = {
    "firstName": {
      "ui:widget": "text",
      "ui:required": true,
      "ui:disabled": true
    },
    "lastName": {
      "ui:widget": "text",
      "ui:required": true,
      "ui:disabled": true
    },
    "emailid": {
      "ui:widget": "text",
      "ui:required": true,
      "ui:disabled": true
    },
    'ui:submitButtonOptions': { norender: true },
    "Tenant": { "ui:widget": "MultipleSelectToStringTanent" },
    "TimeZone": { "ui:widget": "TimezoneSelectWidget" },
    "role": {
      "ui:style": {
        pointerEvents: 'none',
        backgroundColor: 'initial',
        color: 'initial',
        cursor: 'not-allowed',
      },
    }
  };

  // Below useEffect will handle setting uischema on rjsf form
  useEffect(() => {
    if (overlayOpen) {
      const element = document.getElementById("fluent-default-layer-host");
      if (element) { element.style.zIndex = '9999999' }
    };
    (overlayName !== '') ? setUischema(uiSchema2) : setUischema(uiSchema1);
  }, [overlayOpen, overlayName]);

  // Data table column name code starts here
var tableColumns: any[] = [];
    var filterColumns: any[] = [];
    useEffect(() => {
        contextValue?.tableColumnsData?.Administration?.Approvals.forEach((val) => {

            if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
                if (val.key === "createdon_timezoned" || val.key === "modifiedon_timezoned") {
                    tableColumns[val.priority] = ({
                        key: val.key,
                        label:
                            <>
                                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                                    <StackItem>
                                        <Body1Strong>{`${val.name}`}</Body1Strong>
                                    </StackItem>
                                    <StackItem align="center">
                                        <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                                            <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                                        </Tooltip>
                                    </StackItem>
                                </Stack>
                            </>
                    });
                } else {
                    tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
                }
            }

            if (val.display.filter.toLocaleLowerCase() === "yes") {
                filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
            }
        });

        setTableColumnsData(tableColumns);
        setFilterColumnsData(filterColumns);

        contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Administration?.Approvals.filter((val) => val.priority >= 0));

        contextValue.setManageViewPageDetails({ module: "Administration", page: "Approvals" });
    }, [contextValue.tableColumnsData]);
  // Data table for filter column ends here

  useEffect(() => {
    var tempExportData: any = [];
    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      const { userid, firstName, lastName, user_email, userType, Created_on, status, modifiedOn } = val;
      tempExportData.push({
        id: userid,
        'First Name': firstName, 'Last Name': lastName, 'Email': user_email, 'User Type': userType,
        'Created On': convertToExcelFormat(Created_on), 'Status': status, 'Modified On': convertToExcelFormat(modifiedOn)
      });
    });
    setExportData(tempExportData);
  }, [exportDetails]);

  // useEffect(() => {
  //   // Roles and permissions below:
  //   async function loadRoute() {
  //     console.log("Role: ", sessionStorage.getItem('role'))
  //     try {
  //       const [routeAllowed, permissions] = await shouldLoadRoute(sessionStorage.getItem('role'));
  //       console.log("Permission: ", permissions);
  //       (routeAllowed) ? setPermissions(permissions) : console.log('Route is not allowed...');
  //     } catch (error) {
  //       console.error('Error loading route: ', error);
  //     }
  //   }
  //   loadRoute();
  // }, []);

  useEffect(() => {
    var tempTableData: any = [];
    var menuLists: any = [];
    // Data table values append code starts here
    console.log("Checking final_data user: ", final_data);
    // getSiteList(); // getRoles();
    final_data !== undefined && final_data !== null
      ? final_data?.map((val: any, i: any) => {
        const { user_email, userid, firstName, lastName, Created_on, modifiedOn, userStatus } = val;
        const truncateText = (text: string, limit: number) => text.slice(0, limit) + ('...');
        let formattedEmail: any = truncateText(user_email, 14)
        console.log("formattedemail", formattedEmail)
        menuLists.push();
        const pemrit = permissions.includes("all") || permissions.includes("allUsers_Fullaccess");
        const handleEdits = () => { setRowID(userid); setOverlayName('edit'); setOverlayOpen(true); };
        const texts = (text: any) => <Caption1> {text} </Caption1>;

        // console.log("Checking final data email: ", user_email);
        // const formattedEmail = user_email.substring(0, 10) + "\n" + user_email.substring(10, 23) + "\n" + user_email.substring(23);
        // console.log("Checking formattedEmail: ", formattedEmail);

        tempTableData.push({
          id: userid,
          name: user_email,
          checkbox: 'hide',
          firstname: {
            icon: "",
            id: i,
            label: pemrit
              ? <Button style={buttonContent} appearance="transparent" size="small" onClick={handleEdits}> {firstName ?? '-'} </Button>
              : <Tooltip withArrow content="You do not have access" relationship="description" positioning="above">
                {texts(firstName)}
              </Tooltip>
          },
          lastname: { label: texts(`${(lastName != "" ? lastName : "-") || setRowDesc(lastName)}`), status: "" },
          email: {
            label: <Tooltip withArrow content={user_email} relationship="description" positioning="below-start">
              {texts(formattedEmail)}
            </Tooltip>
          },
          usertype: { label: texts(`${'\u00A0'.repeat(4)} ${val?.userType ?? 'local'}`) },
          createdon: { label: texts(`${(Created_on != null && Created_on !== '') ? convertUTCToReadableFormat(Created_on) : '-'} `) },
          createdon_timezoned: { label: texts(`${(Created_on != null && Created_on !== '') ? convertToLocalTimezone(Created_on, userTimeZone) : '-'} `) },
          modifiedon: { label: texts(`${(modifiedOn != null && modifiedOn !== '') ? convertUTCToReadableFormat(modifiedOn) : '-'} `) },
          modifiedon_timezoned: { label: texts(`${(modifiedOn != null && modifiedOn !== '') ? convertToLocalTimezone(modifiedOn, userTimeZone) : '-'} `) },
          status: { label: ((userStatus == 1)) ? texts(`Active`) : texts(`Pending`) },
        });
      }) : (tempTableData = []);

    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
    // setLoading(false);
    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);
  }, [final_data, formDataUser, permissions, rowID]);
  // Data table values append code ends here

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    console.log('Form data: ', formDataUser);
    setoverLayData({
      headerTitle: overlayName == 'edit' ? <Title3> Edit User </Title3> : <Title3> Create User </Title3>,
      size: "large",
      isTabs: true,
      // This is button present in the overlay data presents in the overlay(overlay content)
      tabItems: {
        Introduction: (
          <FluentProvider theme={dashboardTheme}>
            <Stack tokens={{ childrenGap: 15, padding: 10 }}>
              <Form formContext={{ autoComplete: "off" }} ref={formRef} formData={formDataUser} schema={jsonSchema1} uiSchema={uischema} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataUser(e.formData)} />
            </Stack>
          </FluentProvider>
        ),
        "Review Data": (
          <FluentProvider theme={dashboardTheme}>
            <Stack tokens={{ childrenGap: 15, padding: 10 }}>
              <Form disabled={true} formData={formDataUser} schema={jsonSchema1} uiSchema={uiSchemaDisabled} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataUser(e.formData)} />
            </Stack>
          </FluentProvider>
        )
      }
    });
  }, [formDataUser, overlayName, CustomWidgets]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
    contextValue.setSelectedRowIdInSubTable([]);
  }, []);

  useEffect(() => {
    selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
  }, [selectedRowIdInTable, selectedRowIdInSubTable]);

  const empty = <StackItem><Text /></StackItem>;

  const overflowData = () => {
    const extra1 = (
      <>
        {permissions.includes("all") || permissions.includes("allUsers_Fullaccess")
          ? <StackItem onClick={() => { setFormDataUser({}); setCurrentSelectedUserFormDetails({}); setOverlayOpen(true); setOverlayName(''); console.log("Checking overlayname: ", overlayName) }}>
            <Button appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)} shape="circular">
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <AddSquare20Regular {...primaryIcon} /> </StackItem>
                <StackItem> <Caption1> Create User </Caption1></StackItem>
              </Stack>
            </Button>
          </StackItem>
          : <StackItem>
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button appearance="subtle" size="small" disabled shape="circular">
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  {empty}
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem><Caption1> Create User </Caption1></StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          </StackItem>
        }
        <StackItem><Divider vertical /></StackItem>
        <StackItem>
          <DialogBox
            headerButton={
              <Button appearance="transparent" size="small" shape="circular"
                disabled={isdeletedisabled ? true : false} >
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> <KeyResetRegular {...(isdeletedisabled ? secondaryIcon : primaryIcon)} /> </StackItem>
                  <StackItem> <Caption1> Reset Password </Caption1> </StackItem>
                </Stack>
              </Button>
            }
            content="Are you sure you want send the reset link to selected user"
            footer={
              <Stack horizontal tokens={{ childrenGap: 10 }}>
                <StackItem>
                  <Button shape="circular" appearance="primary" /*onClick={() => { sendResetEmail(); }}*/ size="small">Confirm</Button>
                </StackItem>
                <StackItem> <Button shape="circular" size="small"> Cancel </Button> </StackItem>
              </Stack>
            }
          />
        </StackItem>
        <StackItem> <Divider vertical /> </StackItem>
        <StackItem>
          <Button shape="circular" appearance="subtle" size="small" >
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> <SlideEraser20Regular {...primaryIcon} /> </StackItem>
              <DialogBox
                headerButton={
                  <Button shape="circular" appearance="transparent" size="small"
                    disabled={isdeletedisabled ? true : false} >
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <Delete20Regular {...(isdeletedisabled ? secondaryIcon : primaryIcon)} /> </StackItem>
                      <StackItem> <Caption1> Delete </Caption1> </StackItem>
                    </Stack>
                  </Button>
                }
                content="Are you sure you want to delete the user? This action cannot be reverted."
                footer={
                  <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <StackItem>
                      <Button shape="circular" appearance="primary" onClick={() => { setdeleteUser(true); /*userActivity('Delete', `{"summary":"${selectedRowIdInTable.length} user deleled with id ${selectedRowIdInTable}"}`); */ }} size="small"> Confirm </Button>
                      <Button shape="circular" appearance="primary" /*onClick={() => { setDeleteAppMonitored(true) }} */ size="small"> Confirm </Button>
                    </StackItem>
                    <StackItem> <Button shape="circular" size="small"> Cancel </Button> </StackItem>
                  </Stack>
                }
              />
            </Stack>
          </Button>
        </StackItem>
        <StackItem><Divider vertical /></StackItem>
      </>
    );

    const extra2 = (
      <StackItem>
        <Button disabled={loading || tableData.length === 0} shape="circular" appearance="subtle" size="small">
          <Stack tokens={{ childrenGap: 5 }} horizontal>
            <StackItem> <Settings20Regular {...primaryIcon} /> </StackItem>
            <StackItem> <Caption1> Manage View </Caption1> </StackItem>
          </Stack>
        </Button>
      </StackItem>
    );

    const handleRefresh = () => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true) };
    const handleExport = () => { setExportBtnClicked(true) /*userActivity('Export', `{"summary" : "Roles List Exported"}`)*/ };

    const refreshButton = () => (
      <StackItem>
        <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={handleRefresh}>
          <Stack tokens={{ childrenGap: 5 }} horizontal>
            <StackItem> <ArrowClockwise20Regular {...(loading ? secondaryIcon : primaryIcon)} /> </StackItem>
            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
          </Stack>
        </Button>
      </StackItem>
    );

    const exportButton = () => {
      const permits = permissions.includes("all") || permissions.includes("approvals_ReadandExport") || permissions.includes("approvals_Fullaccess");
      const exportIcons = (icons: any) => (
        <Stack tokens={{ childrenGap: 5 }} horizontal>
          <StackItem> {icons} </StackItem>
          <StackItem> <Caption1> Export </Caption1> </StackItem>
        </Stack>
      );
      return permits
        ? <StackItem>
          <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_users.csv`} />
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={handleExport}>
            {exportIcons(<ArrowDownload20Regular {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} />)}
          </Button>
        </StackItem>
        : <StackItem>
          <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
            <Button shape="circular" appearance="subtle" size="small" disabled>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                {empty}
                <StackItem> {exportIcons(<ArrowDownload20Regular {...secondaryIcon} />)} </StackItem>
              </Stack>
            </Button>
          </Tooltip>
        </StackItem>
    };

    const fullscreenButton = () => (
      <StackItem grow shrink>
        <Stack horizontalAlign="end"> <StackItem grow shrink> <FullScreenButton handle={handle} /> </StackItem> </Stack>
      </StackItem>
    );

    const overFlowComponent = {
      data:
        <>
          {/* {extra1} */}
          {refreshButton()}
          {exportButton()}
          {/* {extra2} */}
          {fullscreenButton()}
        </>
    };
    return <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
  };

  const filtersData = () => {
    const commonExist = () => <span style={{ color: 'red' }}> This column is already filtered </span>;
    const commonInputs = () => <Input size="small" onChange={inputChange} name="filter" value={dropDownValue2} />;
    const commonFilterArray = () => filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`));
    const commonFilter = () => commonFilterArray() ? commonExist() : commonInputs();
    const handleApply = () => { handleFilterArray(); setFilterMenuOpen(false); };
    const handleCancel = () => { setFilterMenuOpen(false); handleCloseFilter("") };
    const handleReset = () => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); };
    const disableApply = !dropDownValue1 || !dropDownValue2 || commonFilterArray();

    const filterButton = () => (
      <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
        <Stack tokens={{ childrenGap: 5 }} horizontal>
          <Filter20Filled {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} />
          <Body1> Filter </Body1>
        </Stack>
      </MenuButton>
    );

    const addFilterData = () => (
      <>
        <Body1Strong> Add a Filter </Body1Strong>
        <Divider />
        <MenuList>
          <Stack tokens={{ childrenGap: 5 }}>
            <StackItem> <Text /> </StackItem>
            <StackItem> <Caption1> Filter </Caption1> </StackItem>
            <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
            <StackItem> <Divider /> </StackItem>
            <StackItem> <Caption1> Value </Caption1> </StackItem>

            {
              (dropDownValue1 === 'Created On' || dropDownValue1 === 'Modified On') &&
              (commonFilterArray() ? commonExist() : <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />)
            }
            {(dropDownValue1 === 'First Name' || dropDownValue1 === 'Last Name') && commonFilter()}
            {dropDownValue1 === "Status" && commonFilter()}
            {(dropDownValue1 === 'Email') && commonInputs()}
            {
              dropDownValue1 === 'User Type' &&
              <DropdownComponent optionData={uniqueColumn} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />
            }

            <StackItem> <Divider /> </StackItem>
            <Stack tokens={{ childrenGap: 10 }} horizontal>
              <StackItem>
                <Button shape="circular" appearance="primary" onClick={handleApply} disabled={disableApply}>
                  <Caption1> Apply </Caption1>
                </Button>
              </StackItem>
              <StackItem> <Button shape="circular" onClick={handleCancel} > <Caption1> Cancel </Caption1> </Button> </StackItem>
            </Stack>
          </Stack>
        </MenuList>
      </>
    );

    return (
      <>
        <StackItem> <MenuDropdown open={filterMenuOpen} btn={filterButton()} itemVal={addFilterData()} /> </StackItem>
        <StackItem onClick={handleReset}>
          <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> <FilterDismiss20Filled /> </StackItem>
              <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
      </>
    )
  };

  const pageDetails = () => (
    <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
      <StackItem>
        {filterArray.length > 0 && (
          <Stack horizontal wrap>
            {filterArray.map((item, index) => (
              <Button size="small" shape="circular">
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 1 }}>
                      {empty}
                      <StackItem> <Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /> </StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            ))}
          </Stack>
        )}
      </StackItem>
      <StackItem disableShrink>
        {(tableData.length > 0 && !loading) && (
          totalRecords > 0 &&
          <Caption1>
            Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
          </Caption1>
        )}
      </StackItem>
    </Stack>
  );

  const tableDetails = () => (
    <>
      <Users_func filterArray={filterArray} data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} saveUserDetails={saveUserDetails} setSaveUserDetails={setSaveUserDetails} formDataUser={formDataUser} setFormDataUser={setFormDataUser} deleteUser={deleteUser} setDeleteUser={setdeleteUser} setDeleteDisabled={setDeleteDisabled} setEditUserDetails={setEditUserDetails} editUserDetails={editUserDetails} rowId={rowID} setRowID={setRowID} handleEditData={handleEditData} currentSelectedUserFormDetails={currentSelectedUserFormDetails} setCurrentSelectedUserFormDetails={setCurrentSelectedUserFormDetails} setIsToast={setIsToast} isRefresh={isRefresh} setIsRefresh={setIsRefresh} setRefreshToast={setRefreshToast} setExportDetails={setExportDetails} deleteUserToast={deleteUserToast} setdeleteUserToast={setdeleteUserToast} setSiteList={setSiteList} setRoleList={setRoleList} setOverlayOpen={setOverlayOpen} setEmailExistsToast={setEmailExistsToast} exportBtnClicked={exportBtnClicked} setExportBtnClicked={setExportBtnClicked} tenant={tenantName} isApprovalPage={isApprovalPage} />
      {loading
        ? <Stack style={parentHome}> <SkeletonDataTable /> </Stack>
        : tableData.length > 0
          ? <DataTable tableData={tableData} columns={tableColumnsData} />
          : (
            <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}>
              <StackItem> <Text size={500}> No result. </Text> </StackItem>
            </Stack>
          )
      }
    </>
  );

  const toastsData = () => (
    <>
      {overlayName == 'edit' && editUserDetails && <ToastComponent footer="" position="top-end" toastIntent="success" setmessagebar={setIsToast} isToastEnabled={isToast} title="Success" message="User Details Updated Successfully" />}
      {overlayName != 'edit' && isToast && <ToastComponent footer="" position="top-end" toastIntent="success" setmessagebar={setIsToast} isToastEnabled={isToast} title="Success" message="User Details Saved Successfully" />}
      {deleteUserToast && <ToastComponent footer="" position="top-end" toastIntent="success" setmessagebar={setIsToast} isToastEnabled={isToast} title="Success" message="User Detail Deleted Successfully" />}
      {refreshToast && <ToastComponent footer="" position="top-end" toastIntent="success" setmessagebar={setIsToast} isToastEnabled={refreshToast} title="Success" message="Data Table Refreshed" />}
      {isEmailExistsToast && <ToastComponent footer="" position="top-end" toastIntent="warning" setmessagebar={setIsToast} isToastEnabled={isEmailExistsToast} title="Failed" message="Email already exists!" />}
    </>
  );

  return (
    <FullScreen handle={handle} className="fullScreenBackgroundColor">
      <StackItem grow shrink style={BreadcrumbsBorder}>
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          <StackItem grow shrink>
            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
              {empty}
              <StackItem grow shrink>
                <StackItem grow shrink>
                  <Breadcrumbs items={[
                    { name: "Manage", link: "/home" },
                    { name: "Administration", link: "/manage/administration/role" },
                    { name: "SSO", link: "/manage/administration/SSO" },
                    { name: "Approvals", link: "#" },
                  ]} />
                </StackItem>
              </StackItem>
            </Stack>
          </StackItem>
        </Stack>
      </StackItem>
      <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
        <StackItem style={DynamicBoxingCSS}>
          <Stack style={DynamicBoxingCSS}>
            <FluentProvider style={parentHome} theme={dashboardTheme}>
              <Stack style={parentHome} horizontal >
                <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={SSOPages("Approvals")} />
                <StackItem style={DynamicBoxingCSS}>
                  <Stack style={DynamicBoxingCSS} tokens={{ childrenGap: 10 }}>
                    <StackItem >
                      {overflowData()}
                      <Divider />
                    </StackItem>
                    <StackItem>
                      <StackItem style={wraperStyle}>
                        <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                          <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"First Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading} />
                            </StackItem>
                            {filtersData()}
                          </Stack>
                          {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                        </Stack>
                        {pageDetails()}
                      </StackItem>
                    </StackItem>
                    {tableDetails()}
                  </Stack>
                  {toastsData()}
                </StackItem>
              </Stack>
            </FluentProvider>
          </Stack>
          <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} isNavBtn={true} saveBtnFunc={saveBtnFunc} formRef={formRef} pagename={"approvals"} />
        </StackItem>
        {empty}
      </Stack>
    </FullScreen>
  );
};
